"use client";

import { c as _c } from "react/compiler-runtime";
import type { SimilarJob } from "@repo/design-system/types/job";
import { useQuery } from "@tanstack/react-query";
import { similarJobsApi } from "../lib/react-query/api";
import { useClient } from "../utils/client/client";
import { useLocale } from "./use-locale";

/**
 * Deferred similar-jobs fetch for a job ad. Reads through the cacheable
 * `/api/similar-jobs` GET endpoint, so an app adopting this hook has to mount
 * `SimilarJobsApiHandler` at `app/api/similar-jobs/route.ts`.
 */
export function useSimilarJobs(t0) {
  const $ = _c(11);
  const {
    idClient,
    filters,
    initialSimilarJobs,
    enabled
  } = t0;
  const locale = useLocale();
  const client = useClient();
  const hasInitialSimilarJobs = !!initialSimilarJobs?.length;
  let t1;
  let t2;
  if ($[0] !== client || $[1] !== filters || $[2] !== idClient || $[3] !== locale) {
    t1 = ["similar-jobs", idClient, locale, client, filters];
    t2 = () => similarJobsApi.fetchSimilarJobs({
      id: idClient,
      filters,
      locale,
      client
    });
    $[0] = client;
    $[1] = filters;
    $[2] = idClient;
    $[3] = locale;
    $[4] = t1;
    $[5] = t2;
  } else {
    t1 = $[4];
    t2 = $[5];
  }
  const t3 = hasInitialSimilarJobs ? initialSimilarJobs : undefined;
  const t4 = enabled && !hasInitialSimilarJobs;
  let t5;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3 || $[9] !== t4) {
    t5 = {
      queryKey: t1,
      queryFn: t2,
      initialData: t3,
      enabled: t4,
      staleTime: 900000
    };
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return useQuery(t5);
}